import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericDecimalInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';


const ExcessInput: InputWithoutSource = ({ input }) => (
    <GenericDecimalInput label={input.name} input={input} precision={0} />
);

ExcessInput.meta = {
    inputType: InputModel.name
};

export default observer(ExcessInput);
